import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Box,
  Modal,
  Tooltip,
  Typography,
  Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddSource = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [SourceName, setSourceName] = useState('');
  const navigate = useNavigate();

  const handleSave = (e) => {
    e.preventDefault();
    if (SourceName) {
      console.log('Source saved:', SourceName);
      setShowSuccessModal(true);
    }
  };

  const handleCancel = () => {
    setSourceName('');
  };

  return (
<Container>
  {/* ================= HEADER ================= */}
  <Box
    sx={{
      backgroundColor: "rgba(2, 78, 101, 1)",
      padding: "12px 16px",
      boxShadow: 3,
      borderRadius: "4px 4px 0 0",
      margin: "0 auto",
      width: "100%",
    }}
  >
    <Typography
      variant="h4"
      sx={{
        color: "#fff",
        fontWeight: "bold",
      }}
    >
      Add Source
    </Typography>
  </Box>

  {/* ================= FORM ================= */}
  <Paper
    elevation={3}
    sx={{
      p: 2,
      width: "100%",
      margin: "24px auto 0",
      backgroundColor: "#f8fdfe",
    }}
  >
    <Box>
      <TextField
        label="Source"
        variant="outlined"
        fullWidth
        value={SourceName}
        onChange={(e) => setSourceName(e.target.value)}
        placeholder="e.g. WhatsApp, Facebook, Instagram, Website, Referral"
        sx={{
          mb: 3,
        }}
      />

      {/* ================= BUTTONS ================= */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
        }}
      >
        <Tooltip
          title={!SourceName ? "Enter Source" : ""}
          arrow
        >
          <span>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={!SourceName}
              sx={{
                backgroundColor: "#127498",
                "&:hover": {
                  backgroundColor: "#116280",
                },
              }}
            >
              SAVE
            </Button>
          </span>
        </Tooltip>

        <Button
          variant="contained"
          color="error"
          onClick={handleCancel}
        >
          RESET
        </Button>
      </Box>
    </Box>
  </Paper>

  {/* ================= SUCCESS MODAL ================= */}
  <Modal
    open={showSuccessModal}
    onClose={() => setShowSuccessModal(false)}
    aria-labelledby="success-modal-title"
    aria-describedby="success-modal-description"
  >
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: 24,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#0B1F40",
          padding: "12px 16px",
        }}
      >
        <Typography
          id="success-modal-title"
          variant="h6"
          sx={{
            color: "#fff",
          }}
        >
          Source Added ✅
        </Typography>
      </Box>

      <Box sx={{ padding: "20px" }}>
        <Typography
          id="success-modal-description"
          sx={{ mb: 2 }}
        >
          Source Added Successfully
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 3,
          }}
        >
          <Button
            onClick={() => {
              setShowSuccessModal(false);
              navigate(-1);
            }}
            variant="contained"
            color="primary"
          >
            OK
          </Button>
        </Box>
      </Box>
    </Box>
  </Modal>
</Container>
  );
};

export default AddSource;